
const m = window.require("discourse/lib/environment");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
